import { getData } from "./Http/api";

const LIMITE_POR_DEFECTO = 100;

const PERFIL_POR_DEFECTO = {
  limiteRegistros: LIMITE_POR_DEFECTO,
  puedeReasignarCasos: false,
  puedeGestionarDisparador: false,
  puedeEditarCalendario: false,
  gestionesMinimasDia: 0,
};

// Configuración del perfil del usuario logueado (límite de registros, privilegios).
// Se pide una vez por sesión de la SPA y se reutiliza en las pantallas de casos; los
// cambios hechos en Perfiles se ven al volver a iniciar sesión (o recargar la página).
let perfilEnCurso = null;

export const fetchPerfilActual = () => {
  const idPerfil = parseInt(localStorage.getItem("idPerfil") || "0", 10);
  if (!idPerfil) {
    return Promise.resolve({ ...PERFIL_POR_DEFECTO });
  }
  if (!perfilEnCurso || perfilEnCurso.idPerfil !== idPerfil) {
    perfilEnCurso = {
      idPerfil,
      promesa: getData(`PerfilGet/${idPerfil}`)
        .then((res) => ({
          limiteRegistros: res?.value?.limiteRegistros > 0 ? res.value.limiteRegistros : LIMITE_POR_DEFECTO,
          puedeReasignarCasos: !!res?.value?.puedeReasignarCasos,
          puedeGestionarDisparador: !!res?.value?.puedeGestionarDisparador,
          puedeEditarCalendario: !!res?.value?.puedeEditarCalendario,
          gestionesMinimasDia: res?.value?.gestionesMinimasDia > 0 ? res.value.gestionesMinimasDia : 0,
        }))
        .catch((ex) => {
          console.error("Error cargando el perfil del usuario:", ex);
          perfilEnCurso = null;
          return { ...PERFIL_POR_DEFECTO };
        }),
    };
  }
  return perfilEnCurso.promesa;
};
